import { PokemonSprite } from "@/components/pokemon/pokemon-sprite";
import { Pokemon } from "prisma-layer";
import { Direction } from "types/battle-engine/battle";
import classNames from "classnames";
import { FACTION_NAME, FACTIONS } from "game/data/factions";
import { POKE_DATA } from "game/data/pokemon/data";
import { PokeNames } from "types/pokemon/poke-names";

interface PokemonCampaignTeamDisplayProps {
  pokemons: Array<
    Pick<Pokemon, "id" | "display_id" | "base_pokemon_name" | "level">
  >;
  className?: string;
  campaignFaction?: FACTION_NAME | undefined;
}

export function PokemonCampaignTeamDisplay({
  pokemons,
  className,
  campaignFaction,
}: PokemonCampaignTeamDisplayProps) {
  const isAllowed = (pokemon: string) => {
    const pokemonData = POKE_DATA[pokemon as PokeNames];
    if (!pokemonData) return false;

    if (!campaignFaction) return true;

    const factionData = FACTIONS[campaignFaction];

    return factionData.types.some((type) => pokemonData.types.includes(type));
  };

  return (
    <div
      className={classNames(
        "grid grid-cols-4 gap-4 p-2 animate-fadeIn place-items-center overflow-visible",
        className,
      )}
    >
      {pokemons.map((pokemon) => {
        const allowed = isAllowed(pokemon.base_pokemon_name);

        return (
          <div
            key={pokemon.id}
            className="flex flex-col h-14 items-center gap-2 overflow-visible relative"
          >
            <div
              className="relative overflow-visible"
              style={{
                opacity: allowed ? 1 : 0.5,
                filter: allowed ? "none" : "grayscale(100%)",
              }}
            >
              <PokemonSprite
                pokemon={pokemon}
                style={{ scale: 2.5 }}
                className="w-12 h-12"
                showShadow={true}
                direction={Direction.SE}
                animation="Idle"
              />
            </div>
            <div className="bg-pk-gray-1/90  border-pk-blue-3 rounded-md px-2  shadow-md mt-auto absolute bottom-0">
              <span className="text-pk-gray-5 text-[10px] font-bold drop-shadow-sm">
                #{pokemon.display_id.slice(0, 6)}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
